import React, { useState, useEffect, useRef } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import About from './components/About';
import Products from './components/Products';
import Process from './components/Process';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';

export default function App() {
  return (
    <div style={{ background: '#0a0a0a', minHeight: '100vh', overflowX: 'hidden' }}>
      <Navbar />
      <Hero />
      <TrustBar />
      <About />
      <Products />
      <Process />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
      <FloatingActions />
    </div>
  );
}
